export default "__VITE_PUBLIC_ASSET__53855ba1__"